module.exports = __webpack_public_path__ + "img/90b91e4.webp";